import { createAction } from "@reduxjs/toolkit";

export namespace IHeaderModalActions {
  export enum Type {
    // CHAT_FAVORITED exists to carry the one cross-store side effect
    // favoriting a chat has beyond its own request status:
    // account-reducer.ts setting user.has_favorites.
    CHAT_FAVORITED = "CHAT_FAVORITED",

    // FEED_ITEM_DELETED exists to carry the one cross-store side effect
    // deleting a feed item has beyond its own request status:
    // feed-reducer.ts removing the item from `feeds`.
    FEED_ITEM_DELETED = "FEED_ITEM_DELETED",
  }

  export const chatFavorited = createAction(Type.CHAT_FAVORITED);

  export const feedItemDeleted = createAction<{ id: string }>(
    Type.FEED_ITEM_DELETED
  );
}

export type HeaderModalActions = Omit<typeof IHeaderModalActions, "Type">;
